module.exports = __webpack_public_path__ + "static/media/5.345a457c.jpg";